<template>
  <section style="overflow-x: hidden;">
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-detail-header">
        <div class="util-header-top">
          <div class="util-detail-header-title">
            <strong>Informasi Awal</strong>
            <br>
          </div>
        </div>
      </div>
      <b-container>
        <section class="summary">
          <div class="sum-title">
            <strong>{{ data?.machine?.name }}</strong>
            <span :class="data?.status">{{ data?.status }}</span>
          </div>
          <hr />
          <div class="sum-row">
            <span class="gray">Start At</span>
            <span>{{ dayjs(data?.downtime_at).format("DD/MM/YYYY HH:mm") }}</span>
          </div>
          <div class="sum-row">
            <span class="gray">Shift</span>
            <span>{{ data?.shift }}</span>
          </div>
          <div class="sum-row">
            <span class="gray">Dateline Preventive</span>
            <span>{{ dayjs(data?.preventive_due_at).format("DD/MM/YYYY HH:mm")  }}</span>
          </div>
        </section>
        <section class="task-detail" >
          <strong>Problem</strong>
          <p v-html="data?.problems"></p>
          <hr style="transform: scale(1.2);margin-block: 28px;">
          <h2>Hasil Analisa</h2>
          <strong>Why 1</strong>
          <textarea placeholder="Tulis Deskripsi" v-model="why_1"></textarea>
          <strong>Why 2</strong>
          <textarea placeholder="Tulis Deskripsi" v-model="why_2"></textarea>
          <strong>Why 3</strong>
          <textarea placeholder="Tulis Deskripsi"  v-model="why_3"></textarea>
          <strong>Corrective</strong>
          <textarea placeholder="Tulis Deskripsi" v-model="corrective"></textarea>
          <strong>Preventive</strong>
          <textarea placeholder="Tulis Deskripsi" v-model="preventive"></textarea>
          <strong>Durasi Downtime (min)</strong>
          <div class="flex">
            <input type="text" placeholder="120" v-model="downtime_minute">
            <button @click="untilnow">Sampai Sekarang</button>
          </div>
        </section>
      </b-container>
    </section>
    <util-action @submit="submit"></util-action>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import dayjs from 'dayjs'
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Search from "@/components/Search.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilAction from "@/views/pages/Utilities/Components/Util-Action.vue";
import { api } from "@/api/api";

@Component({
    components: {
        MenuFooter,
        Search,
        ValidationObserver,
        ValidationProvider,
        UtilAction
    },
})
export default class Utilities extends Vue {
    isActive = false
    errors = []
    toDate(e) {
      e.target.type = 'date'
    }
  toText(e) {
    if(!e.target.value){
      e.target.type = 'text'
    }
  }
    why_1 = null
    why_2 = null
    why_3 = null
    corrective = null
    preventive = null
    downtime_minute = null

    dayjs = dayjs
    // get id from url
    id = this.$route.params.id
    data = null
    mounted(){
      api('downtime_detail',{route:'/'+this.id}).then(res=>{
        this.data = res.data
        this.why_1 = res.data.why_1
        this.why_2 = res.data.why_2
        this.why_3 = res.data.why_3
        this.corrective = res.data.corrective
        this.preventive = res.data.preventive
        this.downtime_minute = res.data.downtime_minute

      })
    }
    untilnow(){
      // count the minute between now and downtime_at
      this.downtime_minute =  dayjs().diff(dayjs(this.data?.downtime_at),'minute')
    }
    submit(){
      if( this.id && this.why_1 && this.why_2 && this.why_3 && this.corrective && this.preventive && this.downtime_minute){ 
      api('downtime_process',{ body:{
        id: this.id,
        why1: this.why_1,
        why2: this.why_2,
        why3: this.why_3,
        corrective: this.corrective,
        preventive: this.preventive,
        downtime_minute: this.downtime_minute
      }}).then(()=>{
        this.$router.push('/downtime')
      })
    }
    }
    
}
</script>
